//---- components ---------
//---- mixins -------------
//---- services -----------
import DSService from '../services/ds.service.js';
//---- other --------------
//---- 3rd-parties --------

export const initialState = {
  dsDashboardInitData: null,
  serviceSessionsData: null,
  workgroupsData: null,
  dsDetails: null,
  dsNoteData: null,
  dsStatusData: null,
  dsAttachmentData: null,
  dsAuditTrailData: null,
  openedDSFromTab: null,
  page: 1,
  pageSize: 10,
  dashboardTabs: new Map(),
  dsActiveTab: null,
  dsDetailActiveTab: null,
  templateView: null,
  filterName: null,
  filterValue: "",
  sortBy: "",
  sortDesc: ""
}

export const dsDashboard = {
  //---------------- namespaced --------------------------------------------
  namespaced: true,
  //----------------- state ------------------------------------------------
  state: { ...initialState },
  //----------------- vuex actions  -----------------------------------------
  actions: {
    //get the dashboard init data
    async getDSDashboard({ commit }) {
      const res = await DSService.DSDashboardService.getDSDashboardInit();
      if (res.data) {
        await commit('setDSDashboardData', res.data);
        await commit('addDashboardTab', { 'tabTitle': 'label.diagnosticSessions', 'tabId': 'Default' });
      }
      return res;
    },
    
    //get the repair history init data
    async getDSRepairHistoryInit({ commit }) {
      const res = await DSService.DSDashboardService.getDSRepairHistoryInit();
      if (res.data) {
          await commit('setDSDashboardData', res.data);
          await commit('addDashboardTab', { 'tabTitle': 'label.dsCaseStatus.repairHistory', 'tabId': 'Default' });
      }
      return res;
    },

    //get the repair history sessions list data
    getRepairHistorySessionsData({ commit }, reqParams) {
      return DSService.DSDashboardService.getRepairHistorySessionsData(reqParams).then(res => {
        if (res.data) {
          commit('setServiceSessionsData', res.data);
          return Promise.resolve(res);
        }
      })
    },

    getDSSearch({ commit }) {
      return DSService.DSDashboardService.getDSSearch().then(response => {
        if (response.data) {
          commit('projectData/setCallCenterData', response.data, { root: true })
        }
      })
    },

    //get the session list data
    getSessionsData({ commit }, pageInfo) {
      return DSService.DSDashboardService.getSessionsData(pageInfo).then(res => {
        if (res.data) {
          commit('setServiceSessionsData', res.data);
          return Promise.resolve(res);
        }
      })
    },

    //get the sessions data by workgroup
    setServiceSessionWorklistData({ commit }, res) {
        if (!res.data)
            return;
        commit('setServiceSessionsData', res.data);
    },

    //get the workgroups list
    getWorkgroupsList({ commit }, params) {
      return DSService.DSDashboardService.getWorkgroupsList(params).then(res => {
        if (res.data) {
          commit('setWorkgroupsList', res.data);
          return Promise.resolve(res);
        }
      })
    },

    // filter sessions data by searchBy
    searchSessionsDetails({ commit }, searchBy) {
      return DSService.DSDashboardService.searchSessionsDetails(searchBy).then(res => {
        if (res.data) {
          commit('setServiceSessionsData', res.data);
          return Promise.resolve(res);
        }
      })
    },

    // filter sessions data of repair history by searchBy
    searchRepairHistorySessionsData({ commit }, searchBy) {
      return DSService.DSDashboardService.searchRepairHistorySessionsData(searchBy).then(res => {
        if (res.data) {
          commit('setServiceSessionsData', res.data);
          return Promise.resolve(res);
        }
      })
    },

    // get the ds create info data
    getdsAddInitInfo() {
      return DSService.DSDashboardService.getdsAddInitInfo();
    },

    // add ds
    addDiagnosticSession({ commit }, dsData) {
      return DSService.DSDashboardService.addDiagnosticSession(dsData)
        .then(response => {
          if (response.data.status == "success") {
            commit('setServiceSessionsData', []);
            return response;
          }
        });
    },

    // get ds models
    getModels() {
      return DSService.DSDashboardService.getModels();
    },

    //get the ds details
    getDSDetails({ commit }, reqData) {
      return DSService.DSDetailsService.getDSDetails(reqData).then(response => {
        if (response.data) {
          commit('setDSDetailsData', response.data);
          return Promise.resolve(response);
        }
      })
    },

    //get the ds details tabs content info 
    getDSDetailsTabsContent({ commit }, reqData) {
      return DSService.DSDetailsService.getDSDetailsTabsContent(reqData).then(response => {
        if (response.data) {
          commit('setDetailsTabsContentData', { resData: response.data, resType: reqData.get('action') });
          return Promise.resolve(response);
        }
      })
    },

    //set the status from case view
    setStatus({ commit }, formData) {
      return DSService.DSDetailsService.setStatus(formData).then(
        response => {
          commit("setStatusData", response.data)
          return response.data;
        });
    },

    // set dashboard tabs
    addDsDashboardTab({ commit }, tabInfo) {
      commit('addDashboardTab', tabInfo);
      return;
    },

    // delete dashboard tabs
    removeDsDashboardTab({ commit }, tabInfo) {
      commit('removeDashboardTab', tabInfo);
      return;
    },

    //clear dashboard Tabs
    clearDsDashboardTabs({ commit }) {
      commit('clearDashboardTabsData');
      return;
    },

    //clear sessions data 
    clearServiceSessionsData({ commit }) {
      commit('setServiceSessionsData', null);
      return;
    },

    // clear the DsDashboardInit data
    clearDsDashboardInitData({ commit }) {
      commit('setDSDashboardData', null);
      return;
    },

    // set the opened ds from tab
    setOpenedDSFromTab({ commit }, tabInfo) {
      commit('setOpenedDSFromTab', tabInfo);
      return;
    },

    // set the current page
    setCurrentPage({ commit }, currentPage) {
      commit('setCurrentPage', currentPage);
      return;
    },

    // set the current template view
    setCurrentTemplateView({ commit }, currentView) {
      commit('setCurrentTemplateView', currentView);
      return;
    },

    // set current active DS tab
    setCurrentActiveDSTab({ commit }, currentTab) {
      commit('setCurrentActiveDSTab', currentTab);
      return;
    },

    // set current active DS Detail tab
    setCurrentActiveDSDetailTab({ commit }, currentTab) {
      commit('setCurrentActiveDSDetailTab', currentTab);
      return;
    },

    // set current FilterName
    setFilterName({ commit }, filterName) {
      commit('setFilterName', filterName);
      return;
    },

    // set current FilterValue
    setFilterValue({ commit }, filterValue) {
      commit('setFilterValue', filterValue);
      return;
    },

    // set SortBy
    setSortBy({ commit }, sortBy) {
      commit('setSortBy', sortBy);
      return;
    },

    // set SortDesc
    setSortDesc({ commit }, sortDesc) {
      commit('setSortDesc', sortDesc);
      return;
    },

    // clear sort filter
    clearSortfilter({ commit }) {
      commit('setSortBy', "");
      commit('setSortDesc', "");
      return;
    }
  },
  //---------------------mutations ----------------------------------------------
  mutations: {
    setDSDashboardData(state, dsDashboardData) {
      state.dsDashboardInitData = dsDashboardData;
    },

    setStatusData(state, dsStatusData) {
      state.dsStatusData = dsStatusData;
    },

    setServiceSessionsData(state, sessionData) {
      state.serviceSessionsData = sessionData;
    },
    setWorkgroupsList(state, responseData) {
      state.workgroupsData = responseData
    },

    setDSDetailsData(state, dsDetailsData) {
      state.dsDetails = dsDetailsData;
    },

    addDashboardTab(state, tabData) {
      //https://stackoverflow.com/questions/47269113/vuex-state-map-value-changes-dont-propagate?noredirect=1&lq=1
      //force reactivity by replacing the Map in state with a clone within the mutation.
      state.dashboardTabs.set(tabData.tabId, tabData.tabTitle);
      state.dashboardTabs = new Map(state.dashboardTabs)
    },

    removeDashboardTab(state, tabData) {
      //https://stackoverflow.com/questions/47269113/vuex-state-map-value-changes-dont-propagate?noredirect=1&lq=1
      //force reactivity by replacing the Map in state with a clone within the mutation.
      state.dashboardTabs = new Map(state.dashboardTabs)
      state.dashboardTabs.delete(tabData.tabId);
    },

    clearDashboardTabsData(state) {
      //https://stackoverflow.com/questions/47269113/vuex-state-map-value-changes-dont-propagate?noredirect=1&lq=1
      //force reactivity by replacing the Map in state with a clone within the mutation.
      state.dashboardTabs = new Map(state.dashboardTabs)
      state.dashboardTabs.clear();
    },
    
    setDetailsTabsContentData(state, dsDetailsTabsContentData) {
      switch (dsDetailsTabsContentData.resType) {
        case 'get_notes':
          state.dsNoteData = dsDetailsTabsContentData.resData
          break;
        case 'get_attachments':
          state.dsAttachmentData = dsDetailsTabsContentData.resData
          break;
        case 'get_audittrail':
          state.dsAuditTrailData = dsDetailsTabsContentData.resData
          break;
      }
    },
    setOpenedDSFromTab(state, tabInfo) {
      state.openedDSFromTab = tabInfo;
    },
    setCurrentPage(state, currentPage) {
      state.page = currentPage;
    },
    setCurrentTemplateView(state, currentView) {
      state.templateView = currentView;
    },
    setCurrentActiveDSTab(state, currentTab) {
      state.dsActiveTab = currentTab;
    },
    setCurrentActiveDSDetailTab(state, currentTab) {
      state.dsDetailActiveTab = currentTab;
    },
    setFilterName(state, filterName) {
      state.filterName = filterName;
    },
    setFilterValue(state, filterValue) {
      state.filterValue = filterValue;
    },
    setSortBy(state, sortBy) {
      state.sortBy = sortBy;
    },
    setSortDesc(state, sortDesc) {
      state.sortDesc = sortDesc;
    },
    error(state) {
      state.dsDashboardData = null;
      state.serviceSessionData = null;
      state.dsAddInitInfo = null;
      state.models = null;
    }
  },
}